module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_0.a771ad40.png";